export const changeDistance = {
  _validation: {
    distance: {
      presence: {
        allowEmpty: false,
        message: '^changeDistance.validation.required',
      },
    },
  },
};
